import Vue from 'vue'
import _this from '../main.js';
let notify ={};

	notify.success = function (text='成功',callback,duration=1000) {
		var ins = _this.$notify.success({
          title: text,
          onClose: callback,
          duration: duration
        });
        return ins
	}
    

	notify.error = function (text='错误',callback,duration=1000) {
		var ins = _this.$notify.error({
          title: text,
          onClose: callback,
          duration: duration
        });
        return ins
	}

	notify.info = function (text='消息',callback,duration=1000) {
		var ins = _this.$notify.info({
          title: text,
          onClose: callback,
          duration: duration
        });
        return ins
	}

	notify.warning = function (text='警告',callback,duration=1000) {
		var ins = _this.$notify.warning({
          title: text,
          onClose: callback,
          duration: duration
        });
        return ins
	}

    notify.wait = function (text='请稍等',callback,duration=1000) {
        var ins = _this.$notify({
          title: text,
          onClose: callback,
          duration: duration,
          iconClass: 'el-icon-loading'
        });
        return ins
    }

//请求失败错误信息打印message
    const errorMsg = function(response) {
      var msg = _this.$message.error(response.data.errorMsg?response.data.errorMsg:response.data.code);
    }


Vue.prototype.notify = notify;
Vue.prototype.errorMsg = errorMsg;


export default notify



// WEBPACK FOOTER //
// ./src/utils/notify.js